import React, { useEffect, useState } from 'react';
import { Assets } from '@src/svg/assets';

// 아이콘 파일 로드
const loadIcon = async (iconName: keyof typeof Assets) => {
  if (!Assets[iconName]) {
    throw new Error(`Icon ${iconName} not found`);
  }
  const module = await Assets[iconName]();
  return module.default;
};

const Icon = ({
  name,
  ...props
}: { name: keyof typeof Assets } & React.SVGProps<SVGSVGElement>) => {
  const [IconComponent, setIconComponent] = useState<React.FC<
    React.SVGProps<SVGSVGElement>
  > | null>(null);

  useEffect(() => {
    loadIcon(name)
      .then((component) => setIconComponent(() => component))
      .catch(() => setIconComponent(null));
  }, [name]);

  if (!IconComponent) {
    return <svg {...props} />; // 아이콘 파일 로드 전 영역 고정
  }
  return <IconComponent {...props} />;
};

export default Icon;
